import * as React from "react";
const SvgFiRrAngle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-angle_svg__a)">
      <path
        fill="#062147"
        d="M17.214 10.106a1 1 0 0 1 1.639-1.147 17.5 17.5 0 0 1 1.639 2.893 1 1 0 1 1-1.826.816c-.4-.896-.888-1.758-1.452-2.562m2.504 5.903c.187.965.282 1.958.282 2.952a1 1 0 1 0 2 0c0-1.121-.107-2.242-.318-3.333a1 1 0 1 0-1.964.381M12.665 5.805a15.6 15.6 0 0 1 2.066 1.529.999.999 0 1 0 1.318-1.504 17.4 17.4 0 0 0-2.333-1.727 1 1 0 1 0-1.051 1.702m10.334 16.194H4.019a1.98 1.98 0 0 1-1.72-.979 1.98 1.98 0 0 1-.037-1.978l9.567-17.563a1 1 0 1 0-1.757-.957L.505 18.087a3.97 3.97 0 0 0 .074 3.956A3.97 3.97 0 0 0 4.018 24h18.98a1 1 0 1 0 0-2.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-angle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAngle;
